import React from 'react';
import WebChatContainerPlain from './WebChatContainerPlain';
// import WebChatContainer from './WebChatContainer';
import './styles/globals.css';

const App = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex flex-col flex-1 bg-white"><WebChatContainerPlain /></main>
    </div>
  );
};

export default App;